export const es = {
  message: 'Hola mundo componente',
  codigo: 'Código',
  nombre: 'Nombre',
  activo: 'Activo'
}



// WEBPACK FOOTER //
// ./src/lang/es.js